import { ErpDataTableV2 } from '@/components/custom/erp';

import { useState } from 'react';
import { useActionBarHandler, useBaoCaoTongHopHangBanTraLai, useTableData } from './hooks';
import InitialSearchDialog from './components/InitialSearchDialog';
import ActionBar from './components/ActionBar';

export default function BaoCaoTongHopHangBanTraLai() {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [showTable, setShowTable] = useState(false);
  const [searchParams, setSearchParams] = useState<BanHangRecord>({});

  const { data, isLoading, fetchData, refreshData } = useBaoCaoTongHopHangBanTraLai(searchParams);
  const { tables, handleRowClick } = useTableData(data);
  const {
    handleSearchClick,
    handlePrintClick,
    handleRefreshClick,
    handleFixedColumnsClick,
    handleExportDataClick,
    handleEditPrintTemplateClick
  } = useActionBarHandler({
    setInitialSearchDialogOpen,
    refreshData
  });

  const handleInitialSearchClose = () => {
    if (showTable) {
      setInitialSearchDialogOpen(false);
    }
  };

  const handleInitialSearch = async (values: BanHangPayload) => {
    setSearchParams(values);
    setShowTable(true);
    setInitialSearchDialogOpen(false);

    // Fetch data using the hook
    await fetchData(values);
  };

  return (
    <div className='flex h-full min-h-[calc(100vh-64px)] w-screen flex-col overflow-auto'>
      <InitialSearchDialog
        open={initialSearchDialogOpen}
        onClose={handleInitialSearchClose}
        onSearch={handleInitialSearch}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={handlePrintClick}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
          />

          <div className='flex-1 overflow-hidden'>
            {!isLoading && <ErpDataTableV2 tables={tables} onRowClick={handleRowClick} />}
          </div>
        </>
      )}
    </div>
  );
}
